import { Box, type SxProps, type Theme } from "@mui/material";

type FlagIconProps = {
  countryCode: string;
  label?: string;
  sx?: SxProps<Theme>;
};

export function FlagIcon({ countryCode, label, sx }: FlagIconProps) {
  return (
    <Box
      component="span"
      className={`fi fi-${countryCode.toLowerCase()}`}
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      sx={{
        display: "inline-block",
        flexShrink: 0,
        lineHeight: 1,
        borderRadius: "2px",
        ...sx,
      }}
    />
  );
}